import { type ComponentProps } from 'react'
import { Field as BaseField } from '@base-ui/react/field'
import { twMerge } from 'tailwind-merge'
import { LEADING_LAYOUT } from './styles'
import type { PartProps } from '../../../lib/part-props'

interface FieldItemProps extends PartProps<ComponentProps<typeof BaseField.Item>> {
  className?: string
}

/**
 * One option in a radio or checkbox group: its control, label and note, laid out like a leading
 * Field. The group sits in a single Field (its label names the set); each option is an Item, so
 * the option labels wire to their own control rather than to the group.
 */
function FieldItem({ className, ...props }: FieldItemProps) {
  return (
    <BaseField.Item
      data-slot="field-item"
      className={twMerge(
        LEADING_LAYOUT,
        // The Field's own disabled rule skips controls inside an Item, so each Item greys its own label.
        '[&:has(:disabled)>[data-slot=field-label]]:text-foreground-disabled [&:has(:disabled)>[data-slot=field-label]]:cursor-not-allowed',
        '[&:has(:disabled)>[data-slot=field-note]]:text-foreground-disabled',
        className,
      )}
      {...props}
    />
  )
}

export { FieldItem }
export type { FieldItemProps }
